<div class="d-flex mt-3">
  <div class="form-group mr-3">
    <div *ngIf="!isSleeveAggregate">Account : {{ accountId }}</div>
    <div>Security : {{ securityDetails }}</div>
    <div>Description : {{ securityDescription }}</div>
  </div>

  <div class="d-flex">
    <nf-form-control label="Use Prices From" class="mr-3">
      <ng-select
        [(ngModel)]="selection"
        (ngModelChange)="onSelection($event)"
        [items]="selectOptions"
        bindLabel="name"
        [clearable]="false"
        [required]="true"
        [searchable]="false"
        [closeOnSelect]="false"
      >
      </ng-select>
    </nf-form-control>

    <nf-form-control class="mr-3 mt-3">
      <nf-daterange
        [(ngModel)]="daterange"
        [format]="dateFormat"
        (ngModelChange)="onDateApply($event)"
        [disabled]="options.disabled"
        [min]="options.min"
        [max]="options.max"
        [beginDateRequired]="options.beginDateRequired"
        [endDateRequired]="options.endDateRequired"
        [templates]="customDateTemplates"
      >
      </nf-daterange>
    </nf-form-control>
    <nf-form-control label="Accounts" class="mr-3" *ngIf="isSleeveAggregate">
      <ng-select
        placeholder="Select Account"
        *nfLoader="isLoadingSubSleeveAccounts"
        [formControl]="selectedAccount"
        [items]="subAccounts"
        bindValue="id"
        bindLabel="displayLabel"
        [clearable]="false"
        [searchable]="false"
        style="min-width: 10rem"
        [closeOnSelect]="false"
      >
      </ng-select>
    </nf-form-control>
  </div>
</div>
